import { render, staticRenderFns } from "./OdontogramaAtendimento.vue?vue&type=template&id=558290e2&scoped=true"
import script from "./OdontogramaAtendimento.vue?vue&type=script&lang=js"
export * from "./OdontogramaAtendimento.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaAtendimento.vue?vue&type=style&index=0&id=558290e2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558290e2",
  null
  
)

export default component.exports